var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.914,
    height: 39.93,
    viewBox: "0 0 99.914 39.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(-102 -414.247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M-15.276.3,66.858,0c3.13,0,5.667,1.969,5.667,4.4V24.879c0,2.429-2.537,4.4-5.667,4.4l-82.134,1.066c-3.13,0-5.667-2.738-5.667-5.167V4.7C-20.943,2.267-18.406.3-15.276.3Z",
    transform: "translate(129.39 413.247)",
    fill: "rgba(0,6,60,0.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(12 35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(-47 218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M-25.941,0H57.769a5.074,5.074,0,0,1,5.145,5V15a5.074,5.074,0,0,1-5.145,5H-25.941a5.074,5.074,0,0,1-5.145-5V5A5.074,5.074,0,0,1-25.941,0Z",
    transform: "translate(174 181)",
    fill: "#00063c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    transform: "translate(90 392)",
    fill: "#66cb35",
    stroke: "#f4f4f3",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M4712.2,2234.5l7.769,9.721-7.769,9.252",
    transform: "translate(-4571.842 -1835)",
    fill: "none",
    stroke: "#646889",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferMarker);
export default __webpack_public_path__ + "static/media/transfer_marker.933e01d99b0dbcf67a77caf1ea8c6b2b.svg";
export { ForwardRef as ReactComponent };